import { useState } from "react";
import { MapContainer, TileLayer, WMSTileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const PLANET_KEY = import.meta.env.VITE_PLANET_KEY;

// BASES ESTÁVEIS (FUNCIONAM SEM ERRO)
const baseLayers = {
  osm: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",

  satellite:
    "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",

  dark:
    "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png",
};

export default function Dashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [mapType, setMapType] = useState("osm");

  return (
    <div style={{ display: "flex", height: "100vh", background: "#0f172a" }}>

      {/* SIDEBAR */}
      <div
        style={{
          width: sidebarOpen ? 240 : 0,
          transition: "0.3s",
          background: "#111827",
          color: "#fff",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          zIndex: 10,
        }}
      >
        {sidebarOpen && (
          <>
            <div style={{ padding: 15, fontWeight: "bold" }}>
              🌾 Savana Agro
            </div>

            <MenuItem icon="🌾" label="Fazendas" />
            <MenuItem icon="🗺️" label="Mapas" />
            <MenuItem icon="📊" label="Relatórios" />
            <MenuItem icon="👤" label="Usuários" />
          </>
        )}
      </div>

      {/* CONTEÚDO */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>

        {/* TOPBAR */}
        <div
          style={{
            height: 55,
            background: "#0b1220",
            color: "#fff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 15px",
            borderBottom: "1px solid #1f2937",
          }}
        >
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            style={{ background: "none", color: "#fff", fontSize: 22 }}
          >
            ☰
          </button>

          <span>🌾 Savana Agro</span>

          <select
            value={mapType}
            onChange={(e) => setMapType(e.target.value)}
            style={{ background: "#1f2937", color: "#fff", padding: 6 }}
          >
            <option value="osm">Mapa</option>
            <option value="satellite">Satélite</option>
            <option value="dark">Escuro</option>
          </select>
        </div>

        {/* MAPA */}
        <div style={{ flex: 1 }}>
          <MapContainer
            center={[-10, -52]}
            zoom={5}
            style={{ height: "100%", width: "100%" }}
          >

            {/* BASE MAP (ESTÁVEL 100%) */}
            <TileLayer
              key={mapType}
              url={baseLayers[mapType]}
            />

            {/* WMS SEU GEO SERVER */}
            <WMSTileLayer
              url="https://proud-around-gem-shareholders.trycloudflare.com/geoserver/wms"
              layers="agro:oeste_bahia_mosaico"
              format="image/png"
              transparent
            />

          </MapContainer>
        </div>

      </div>
    </div>
  );
}

/* MENU */
function MenuItem({ icon, label }) {
  return (
    <div style={{ display: "flex", gap: 10, padding: 12 }}>
      <span>{icon}</span>
      <span>{label}</span>
    </div>
  );
}
